import React from "react";
import { SignupPage } from "@d-m-organization/hub-shared-lib/auth";
import { HubLayout } from "../components/HubLayout.js";
import { privacyUrl, termsUrl } from "../lib/legalUrls.js";

export function SignupRoute() {
  return (
    <SignupPage
      wrapper={HubLayout}
      loginPath="/login"
      // HD-103: legal URLs now derive from stage / env so dev users don't
      // see prod copy or 404s when the marketing site hasn't shipped them.
      legalLinks={{
        termsUrl: termsUrl(),
        privacyUrl: privacyUrl(),
      }}
      ns="common"
    />
  );
}
